import React from "react"
import "./App.css"
import OntologyView from "./Ontology/OntologyView"
import NodeDataLoader from "./Ontology/Model/NodeDataLoader"
import { NodeData } from "./Ontology/Model/types"

function App() {
    const data: NodeData = NodeDataLoader.loadData()
    return (
        <div className="App">
            <OntologyView nodeData={data} />
        </div>
    )
}

export default App
